import React from 'react';
import * as styled from 'styled-components';
import { createGlobalStyle, ThemedStyledComponentsModule, ThemeProvider, ThemeProviderProps } from 'styled-components';
import { PartnerTheme } from './models';

export { PartnerTheme, PartnerThemeProps } from './models';

export const theme: PartnerTheme = require(`./${globals.REACT_APP_PARTNER}`).default;

const GlobalStyle = createGlobalStyle`
  * {
    font-family: ${theme.fonts.primary}
  }
`;

export const PartnerThemeProvider = (props: ThemeProviderProps<PartnerTheme>) => (
  <>
    <GlobalStyle />
    <ThemeProvider {...props} />
  </>
);

const { useTheme } = styled as ThemedStyledComponentsModule<PartnerTheme>;

export { useTheme };



// WEBPACK FOOTER //
// ./packages/smart-home-support/themes/index.tsx